export const dispatchEventToParentWindow = (name: string, value?: any) => {
  window.parent.postMessage(
    {
      name,
      value,
    },
    '*',
  );
};
